import type { ComponentChildren } from "preact";
import { Icon } from "./Icon.tsx";
import type { IconName } from "./Icon.tsx";
import { cx } from "./lib/cx.ts";

export type FeedbackTone = "neutral" | "info" | "success" | "warning" | "danger";
const NOTICE_ICONS = { neutral: "info", info: "info", success: "check", warning: "warning", danger: "warning" } satisfies Record<FeedbackTone, IconName>;
// See Design > UI, "Curator Studio assets". Always spell the state out.
export function StatusBadge({ tone = "neutral", children }: { tone?: FeedbackTone; children: ComponentChildren }) {
  return <span class={cx("ui-status", `ui-tone--${tone}`)}>{children}</span>;
}
export function Notice({ tone = "info", title, children, action, live = false }: {
  tone?: FeedbackTone; title: string; children?: ComponentChildren; action?: ComponentChildren; live?: boolean;
}) {
  return <div class={cx("ui-notice", `ui-tone--${tone}`)} role={live ? (tone === "danger" ? "alert" : "status") : undefined}>
    <Icon name={NOTICE_ICONS[tone]} />
    <div class="ui-notice__body"><strong>{title}</strong>{children && <div>{children}</div>}</div>{action && <div class="ui-notice__action">{action}</div>}
  </div>;
}
